export default [
	{
		bg: '#E0E8F9',
		fg: '#ffffff'
	},
	{
		bg: '#FFE3F4',
		fg: '#ffffff'
	},
	{
		bg: '#FFE9CC',
		fg: '#ffffff'
	},
	{
		bg: '#E8E1F2',
		fg: '#000000'
	},
	{
		// fallback
		bg: '#EEF8FC',
		fg: '#ffffff'
	}
];
